import req from './request'

const ENDPOINTS = {
    orders: '/orders/v2',
    bonusTransactions: '/transactions/wb-bonus-transactions',
    transactions: '/transactions/base-v2',
}

export default {
    orders(payload, param, method) {
        return req[method || 'get'](payload, ENDPOINTS.orders, param)
    },
    bonusTransactions(payload, param, method) {
        return req[method || 'get'](payload, ENDPOINTS.bonusTransactions, param)
    },
    transactions(payload, param, method) {
        return req[method || 'get'](payload, ENDPOINTS.transactions, param)
    },
}
